// extracted by mini-css-extract-plugin
module.exports = {"themeRoot":"AuthorizePayment_themeRoot__ln1rX","paynowButton":"AuthorizePayment_paynowButton__3rU0u","paymentIFrame":"AuthorizePayment_paymentIFrame__2AsEV"};